import BaseComponent from "../../../base/common/BaseComponent";
import AppSetting from "../../../config/AppSetting";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import {
  getTimeZoneString,
  handleAlertUploadFileError,
  procedureStatusValues,
} from "../../publicDictionaryValues";

export default class FileSectionBase extends BaseComponent {
  constructor(props: any) {
    super(props);
    // @ts-ignore
    this.user = this.appSetting.localStorageValue.user.get();
  }

  setUploadFileNum = () => {
    //this is a virtual function
  };

  uploadFileOnSuccess = (result: any, returnPara: any) => {
    //this is a virtual function
  };

  handleUploadLoading = () => {
    //this is a virtual function
  };

  setFileNum = () => {
    //this is a virtual function
  };

  createFiles = () => {
    //this is a virtual function
  };

  setReturnDataList = () => {
    //this is a virtual function
  };

  uploadFileOnError = (result: any) => {
    this.handleUploadLoading();
    console.log(result);
  };

  _saveError = (result: any) => {
    console.log(result);
    this._alertError("Save Failed");
    this.props?.hideLoading?.();
  };

  _submitError = (result: any) => {
    console.log(result);
    this._alertError("Submit Failed");
    this.props?.hideLoading?.();
  };

  hideScrollModal = () => {
    this.setState({
      scrollModalContent: "",
      scrollModalTitle: "",
      isScrollModalOpen: false,
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  handleResetLock = (actionType: any) => {
    const para = {
      procedureId: this.props.procedureId,
      procedureSectionType: actionType,
      setLock: false,
      timeOutMins: 20,
    };
    ProcedureDetailService.setSectionLock(
      para,
      () => {
        const timer = setTimeout(() => {
          window.location.reload();
        }, 0);
        return () => clearTimeout(timer);
      },
      (response: any) => {
        console.log(response.message);
      }
    );
  };

  handleResetLockWithoutRefresh = (actionType: any) => {
    const para = {
      procedureId: this.props.procedureId,
      procedureSectionType: actionType,
      setLock: false,
      timeOutMins: 20,
    };
    ProcedureDetailService.setSectionLock(
      para,
      () => {
        //this.is an empty function
      },
      (response: any) => {
        console.log(response.message);
      }
    );
  };

  getProcedureStatus = (statusId: any) => {
    // @ts-ignore
    return procedureStatusValues[statusId];
  };

  getNewDataList = (datalist: any) => {
    if (datalist !== undefined) {
      const dataListFilter = datalist.filter((item: any) => item !== undefined);
      let newDataList = [];
      if (dataListFilter.length > 0) {
        newDataList = dataListFilter.map((item: any) => {
          return item.data.reduce((result: any, { name, value }: any) => {
            result[name] = value;
            return result;
          }, {});
        });
      }
      return newDataList;
    } else {
      return [];
    }
  };

  checkDeleteDatalist = (datalist: any, lastSavedDataList: any) => {
    return datalist.map((item: any, index: any) => {
      const fileId = item.data.find((x: any) => x.name === "fileId").value;
      const existLine = lastSavedDataList.some((line: any) => {
        const savedId = line.data.find((x: any) => x.name === "fileId").value;
        return savedId === fileId;
      });

      if (existLine) {
        return {
          ...item,
          data: item.data.map((x: any) => {
            if (x.name === "fileOperate") {
              return { name: "fileOperate", value: 3 };
            }

            return x;
          }),
        };
      }
    });
  };

  checkUpdateDatalist = (datalist: any, lastSavedDataList: any) => {
    return datalist.map((item: any) => {
      const fileId = item.data.find((x: any) => x.name === "fileId").value;
      const existLine = lastSavedDataList.some((line: any) => {
        const savedId = line.data.find((x: any) => x.name === "fileId").value;
        return savedId === fileId;
      });

      if (existLine) {
        return {
          ...item,
          data: item.data.map((x: any) => {
            if (x.name === "fileOperate") {
              return { name: "fileOperate", value: 2 };
            }

            return x;
          }),
        };
      }
      return item;
    });
  };

  createLine = (dataList: any, fileId: any, fileName: any) => {
    const lineId = this._generateGUID();
    const fileKey = this._generateGUID();
    dataList.unshift({
      data: [
        { name: "lineId", value: lineId },
        { name: "fileId", value: fileId },
        { name: "fileKey", value: fileKey },
        {
          name: "fileName",
          value: fileName,
        },
        {
          name: "uploadedDate",
          value: this._formateDate(getTimeZoneString(this._getDate())),
        },
        // @ts-ignore
        { name: "uploadByName", value: this.user.identityUserInfo.englishName },
        // @ts-ignore
        { name: "uploadBy", value: this.user.identityUserInfo.internalUserID },
        { name: "note", value: "" },
        { name: "approveDate", value: "" },
        { name: "fileOperate", value: 1 },
      ],
      checked: false,
    });
  };

  hideModal = () => {
    this.setState({
      isModalOpen: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      handleModalCancel: () => {
        //there is a empty function
      },
    });
  };

  getAddFileDto = (item: any) => {
    return {
      FileName: item.name,
      ContainerName: AppSetting.urlPrefix.addFile.ContainerName,
      AccountName: AppSetting.urlPrefix.addFile.AzureAccountName,
      ProductKey: AppSetting.urlPrefix.addFile.ProductKey,
      FolderName: AppSetting.urlPrefix.addFile.ProcedureFileFolder,
    };
  };

  uploadFile = (fileIndex: any, ref: any) => {
    let fileForm = new FormData();
    // @ts-ignore
    let addFileDto = this.getAddFileDto(this.fileList[fileIndex]);
    // @ts-ignore
    fileForm.append("formFile", this.fileList[fileIndex]);
    fileForm.append("addFileDto", JSON.stringify(addFileDto));
    let returnPara = {
      // @ts-ignore
      fileName: this.fileList[fileIndex].name,
      fileIndex: fileIndex,
    };

    this.setUploadFileNum();

    ProcedureDetailService.addFile(
      fileForm,
      // @ts-ignore
      (result: any) => this.uploadFileOnSuccess(result, returnPara, ref),
      this.uploadFileOnError,
      returnPara
    );
  };

  handleFileSelect = (files: any) => {
    this.props.showLoading();
    this.setFileNum();
  };

  FileProcess = (index: any, dataList: any, tableDataList: any, ref: any) => {
    // @ts-ignore
    if (index >= this.fileList.length) {
      // @ts-ignore
      this.fileList.length > 0 && this.uploadFile(0, ref);
      // @ts-ignore
      if (this.replaceList.length) {
        // @ts-ignore
        ref.current.handleReplaceModalConfirm(this.replaceList);
        // @ts-ignore
        this.replaceList = [];
      }
      return;
    }
    if (
      dataList.findIndex(
        // @ts-ignore
        (dataItem: any) => dataItem.value === this.fileList[index].name
      ) !== -1
    ) {
      this.setState({
        isModalOpen: true,
        // @ts-ignore
        modalChildContent: `${this.fileList[index].name} already exists. Do you want to replace it?`,
        modalOkText: "Replace",
        modalCancelText: "Skip",
        handleModalConfirm: () => {
          const dataIndex = tableDataList.findIndex(
            (dataItem: any) =>
              dataItem.data.findIndex(
                // @ts-ignore
                (item: any) => item.value === this.fileList[index].name
              ) !== -1
          );

          if (dataIndex !== -1) {
            // @ts-ignore
            this.replaceList.push(tableDataList[dataIndex]);
            tableDataList.splice(dataIndex, 1);
          }

          ref.current.updateDataList(tableDataList);
          this.hideModal();
          // @ts-ignore
          this.handleFileSelect([this.fileList[index]]);
          this.FileProcess(index + 1, dataList, tableDataList, ref);
        },

        handleModalCancel: () => {
          // @ts-ignore
          this.fileList.splice(index, 1);
          this.hideModal();
          setTimeout(() => this.FileProcess(index, dataList, tableDataList, ref));
        },
      });
    } else {
      // @ts-ignore
      this.handleFileSelect([this.fileList[index]]);
      this.FileProcess(index + 1, dataList, tableDataList, ref);
    }
  };

  /**
   * click upload button to upload file for update process
   * @param {Number} index
   * @param {Array} dataList
   * @param {Array} tableDataList
   * @param {obj} ref
   * @returns
   */
  updateFileProcess = (index: any, dataList: any, tableDataList: any, ref: any) => {
    let isDuplicate = false;
    let duplicateIndex = 0;
    // @ts-ignore
    if (index >= this.fileList.length) {
      // @ts-ignore
      this.fileList.length > 0 && this.uploadFile(0, ref);
      return;
    }
    // @ts-ignore
    this.fileList.forEach((item: any, index: any) => {
      if (dataList.findIndex((dataItem: any) => dataItem.value === item.name) !== -1) {
        isDuplicate = true;
        duplicateIndex = index;
      }
    });
    if (isDuplicate) {
      // @ts-ignore
      this._alertError(`${this.fileList[duplicateIndex].name} already exists.`);
    } else {
      // @ts-ignore
      this.handleFileSelect([this.fileList[index]]);
      this.updateFileProcess(index + 1, dataList, tableDataList, ref);
    }
  };

  handleReplaceFile = (event: any, ref: any) => {
    // @ts-ignore
    this.fileList = [...event.target.files];
    // @ts-ignore
    if (handleAlertUploadFileError(this.fileList)) {
      return;
    }
    const tableDataList = ref.current.getDataList();
    let dataList: any[] = [];
    tableDataList.map((data: any) => {
      const item = data.data.find((dataItem: any) => dataItem.name === "fileName");
      dataList.push(item);
    });

    this.FileProcess(0, dataList, tableDataList, ref);
  };
}
